module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/download-0082a51b305e4c91349b582d53452fef.svg";